import React, { ReactElement } from 'react';
import { ISoundtrack } from '../../../@types/ISoundtrack';
import FullPageSpinner from '../../FullPageSpinner';
import { Accordion } from 'react-bootstrap';

interface IProps {
  media: Array<ISoundtrack>;
  loadingMoreMedia: boolean;
  renderHeader: () => ReactElement<any>;
  renderMedium: (medium: ISoundtrack, index: number) => ReactElement<any>;
  onSelectEventKey: (eventKey: null | string | number) => void;
  className?: string;
}

function MediaFlatList(props: IProps) {
  const onSelect = (eventKey: any) => props.onSelectEventKey(eventKey);
  const mediaMessage = 'Nothing added yet, but feel free to browse around HUDLMusic.com and find other new artists and music to listen to.';

  const renderContent = () => {
    const { loadingMoreMedia, media, renderMedium } = props;
    if (loadingMoreMedia) {
      return <FullPageSpinner className="m-3" />;
    }
    if (media && media.length > 0) {
      return media.map((medium, index) => renderMedium(medium, index));
    }
    return <span className="text-default">{mediaMessage}</span>;
  }

  return (
    <Accordion className={props.className} onSelect={onSelect}>
      {props.renderHeader()}
      {renderContent()}
    </Accordion>
  );
}
export default MediaFlatList;
